import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class GithubService {

  constructor(private http: HttpClient) {
  }

  getProyectos(){
    return this.http.get('https://api.github.com/users/Bryan-Taday/repos')
    // return this.http.get('https://restcountries.eu/rest/v2/lang/es')
      .pipe(
        map( (resp: any[]) =>
          resp.map( proyecto => ({id: proyecto.id, 
                                  name: proyecto.name,
                                  private: proyecto.private,
                                  html_url: proyecto.html_url,
                                  description: proyecto.description,
                                  updated_at: proyecto.updated_at,
                                  language: proyecto.language}))
        )
      )
  }
}
